// Projects.js
import Desktop1 from "../media/Desktop1.png"
import img14 from "../media/img14.jpg"
import img7 from "../media/img7.png"
import img9 from "../media/img9.jpg"
import img5 from "../media/img5.jpg"
export default function Projects() {
    return (
        <section id="projects"
                 className="my-20 w-full flex flex-col gap-5 align-center max-w-5xl mx-auto">
            <h2 className="text-5xl text-emerald-500 font-bold text-center">
                My Projects..
            </h2>
            <br></br>


           {/* left align */}
           
            <div className="p-10 bg-emerald-200 flex flex-col justify-center items-center
                            gap-5 lg:flex-row max-w-5xl mx-auto shadow transition 
                            hover:shadow-xl hover:scale-[102%] w-full">
                <div className="w-80 rounded">
                    <a href=
"https://www.expertdmarc.com/"
                        className="w-full h-full">
                        <img src=
"https://cloud-1de12d.b-cdn.net/media/original/b442e20583fcf617f9cefa4ac0c6251f/logo-small-white.png"
                             alt="Project 1"
                             className="w-full h-full 
                                        bg-cover rounded"/>
                    </a>
                </div>
                <div className="flex flex-col align-center mx-auto gap-4 justify-center flex-1">
                    <h2 className="font-bold text-3xl text-center">
                        <a className="hover:underline"
                            href=
"https://www.expertdmarc.com/">
                            ExpertDMARC
                        </a>
                    </h2>
                    <p>
                    We Stop Hackers From Sending Emails From Your Domain with ExpertDMARC.
                    </p>
                </div>
            </div>
                





           {/* right align */}

           <div className="p-10 bg-emerald-200 flex flex-col justify-center items-center gap-5 
                            lg:flex-row-reverse max-w-5xl mx-auto shadow transition hover:shadow-xl 
                            hover:scale-[102%] w-full">
                <div className="w-80 rounded">
                    <a href=
"https://www.figma.com/design/OdMmKfAOEC8KH8pghANY7q/Untitled?node-id=0-1&t=ZRnS5JPDdBl3MSkn-1"
                       className="w-full h-full">
                        <img src={img5}

                             alt="Project 2"
                             className="w-full h-full bg-cover rounded" />
                             <p>Click to see Figma file</p>
                    </a>
                </div>
                <div className="flex flex-col align-center mx-auto gap-4 justify-center flex-1">
                    <h2 className="font-bold text-3xl text-center">
                        <a className="hover:underline" href=
"https://www.figma.com/design/OdMmKfAOEC8KH8pghANY7q/Untitled?node-id=0-1&t=ZRnS5JPDdBl3MSkn-1">
                           Landing page design 
                           for connecting people
                        </a>
                    </h2>
                    <p>
                        It's website design tamplete for connecting people.
                        That provide a Customer support, varity of tools and functionality
                        with a user-friendly design.


                    </p>
                </div>
            </div>
       
           
           
             {/* left align */}


             <div className="p-10 bg-emerald-200 flex flex-col justify-center items-center
                            gap-5 lg:flex-row max-w-5xl mx-auto shadow transition 
                            hover:shadow-xl hover:scale-[102%] w-full">
                <div className="w-80 rounded">
                    <a href=
"https://www.figma.com/design/d9Fa6PobUXhjNI6i3oOnAk/smart-home?node-id=0-1&t=KV9TGYnjyOgRPAXw-1"
                        className="w-full h-full">
                        <img src={img14}

                             alt="Project 3"
                             className="w-full h-full 
                                        bg-cover rounded"/>
                                        <p>Click to see Figma file</p>
                    </a>
                </div>
                <div className="flex flex-col align-center mx-auto gap-4 justify-center flex-1">
                    <h2 className="font-bold text-3xl text-center">
                        <a className="hover:underline"
                            href=
"https://www.figma.com/design/d9Fa6PobUXhjNI6i3oOnAk/smart-home?node-id=0-1&t=KV9TGYnjyOgRPAXw-1">
                           Smart home website design
                        </a>
                    </h2>
                    <p>
                    Smart home is website landing page design tamplete.
                    A smart home’s referrs to a home ecosystem that is with each other and can be 
                    accessed through one central point—a smartphone, tablet, laptop, or game console.
                     Door locks, televisions, thermostats, home monitors, cameras, lights, and appliances
                      such as the refrigerator can be controlled through one home automation system.

                    </p>
                </div>
            </div>



           {/* right align */}

            <div className="p-10 bg-emerald-200 flex flex-col justify-center items-center gap-5 
                            lg:flex-row-reverse max-w-5xl mx-auto shadow transition hover:shadow-xl 
                            hover:scale-[102%] w-full">
                <div className="w-80 rounded">
                    <a href=
"https://www.figma.com/design/s0acye10Wc5KhGXYDQpCdQ/Untitled?node-id=0-1&t=O8XYjrDNYTBz8FY4-1"
                       className="w-full h-full">
                        <img src={Desktop1}

                             alt="Project 4"
                             className="w-full h-full bg-cover rounded" />
                             <p>Click to see Figma file</p>
                    </a>
                </div>
                <div className="flex flex-col align-center mx-auto gap-4 justify-center flex-1">
                    <h2 className="font-bold text-3xl text-center">
                        <a className="hover:underline" href=
"https://www.figma.com/design/s0acye10Wc5KhGXYDQpCdQ/Untitled?node-id=0-1&t=O8XYjrDNYTBz8FY4-1">
                           Landing page design for a course website
                        </a>
                    </h2>
                    <p>
                        It's website design tamplete for online course websites.
                        That provide a Customer support, varity of certification courses
                        with live support service and a course mentor.


                    </p>
                </div>
            </div>





 
               {/* left align */}
            
               <div className="p-10 bg-emerald-200 flex flex-col justify-center items-center
                            gap-5 lg:flex-row max-w-5xl mx-auto shadow transition 
                            hover:shadow-xl hover:scale-[102%] w-full">
                <div className="w-80 rounded">
                    <a href=
"https://www.figma.com/design/f1RTfOZRcGU2Zc3HafnLEJ/Untitled?node-id=0-1&t=ZRnS5JPDdBl3MSkn-1"
                        className="w-full h-full">
                        <img src={img9}

                             alt="Project 5"
                             className="w-full h-full 
                                        bg-cover rounded"/>
                                        <p>Click to see Figma file</p>
                    </a>
                </div>
                <div className="flex flex-col align-center mx-auto gap-4 justify-center flex-1">
                    <h2 className="font-bold text-3xl text-center">
                        <a className="hover:underline"
                            href=
"https://www.figma.com/design/f1RTfOZRcGU2Zc3HafnLEJ/Untitled?node-id=0-1&t=ZRnS5JPDdBl3MSkn-1">
                          landing page design for URAS
                        </a>
                    </h2>
                    <p>
                    It's a landing page design tamplete of Lamborghini Urus .
                    Lamborghini Urus is the first Super Sport Utility Vehicle 
                    in the world, merging the soul of a super sports car with 
                    the practical functionality of an SUV.

                    </p>
                </div>
            </div>



            


            {/* right align */}


            <div className="p-10 bg-emerald-200 flex flex-col justify-center items-center gap-5 
                            lg:flex-row-reverse max-w-5xl mx-auto shadow transition hover:shadow-xl 
                            hover:scale-[102%] w-full">
                <div className="w-80 rounded">
                    <a href=
"https://www.figma.com/design/PWkC5K0PVLelWTmfdnYDPT/Untitled?node-id=0-1&t=ZRnS5JPDdBl3MSkn-1"
                       className="w-full h-full">
                        <img src={img7}

                             alt="Project 6"
                             className="w-full h-full bg-cover rounded" />
                             <p>Click to see Figma file</p>
                    </a>
                </div>
                <div className="flex flex-col align-center mx-auto gap-4 justify-center flex-1">
                    <h2 className="font-bold text-3xl text-center">
                        <a className="hover:underline" href=
"https://www.figma.com/design/PWkC5K0PVLelWTmfdnYDPT/Untitled?node-id=0-1&t=ZRnS5JPDdBl3MSkn-1">
                           Landing page design for NIKE AIR MAX
                        </a>
                    </h2>
                    <p>
                    NIKE AIR MAX is website landing page design tamplete of  NIKE AIR MAX .
                    It is a shoe product by NIKE.


                    </p>
                </div>
            </div>

            <button type="button" className="text-2xl text-emerald-500 font-bold text-center"> 
           <a href="https://drive.google.com/drive/folders/1eywLRVRUn4j5zaUdu9as-D8fhHe504cQ?usp=drive_link"> click to see more..</a></button>


        </section>
    );
}
